<template>
    <v-dialog v-model="modalProp" max-width="400">
        <v-card>
            <v-card-title
                class="headline green accent-4 white--text elevation-7"
            >
                Account Validation
            </v-card-title>
            <div style="width:80%; margin:auto" class="">
                <v-card-text class="my-5 text-center subtitle-2">
                    {{
                        resultData
                    }}
                </v-card-text>
            </div>

            <v-card-actions>
                <v-spacer />

                <v-btn
                    color="red darken-1"
                    text
                    @click="modalProp = false"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['signUpErrDialog', 'resultData'],
    data: () => ({}),
    computed: {
        modalProp: {
            get() {
                if (this.resultData == '') {
                    return
                } else {
                    return this.signUpErrDialog
                }
            },
            set(val) {
                // console.log("oo dumaan dito");
                this.$emit('pop-signUpErrDialog', val)
            }
        }
    }
}
</script>

<style></style>
